import React from "react";
import { Text } from "@amzn/meridian";
import { Scanner } from "@yudiel/react-qr-scanner";

interface BarcodeScannerProps {
  isScanning: boolean;
  onScan: (result: any) => void;
  onError: (error: any) => void;
}

const isMobile = window.matchMedia('(pointer: coarse)').matches;

const BarcodeScanner: React.FC<BarcodeScannerProps> = ({
  isScanning,
  onScan,
  onError,
}) => {

  const dpr = window.devicePixelRatio || 1;
  const idealWidth = isMobile ? 1280 : Math.floor(window.innerWidth * dpr);
  const idealHeight = isMobile ? 720 : Math.floor(window.innerHeight * dpr);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
      }}
    >
      {isScanning && (
        <Scanner
          onScan={onScan}
          onError={onError}
          formats={['code_128', 'upc_a', 'ean_13']}
          components={{finder: false}}
          allowMultiple={false}
          constraints={{
            facingMode: "environment",
            width: { ideal: idealWidth },
            height: { ideal: idealHeight },
          }}
          styles={{
            container: {
              width: "100%",
              height: "100%",
              position: "absolute",
              top: 0,
              left: 0,
            },
            video: {
              width: "100%",
              height: "100%",
              objectFit: "cover",
            },
          }}
        />
      )}

      {/* Scanning Frame Overlay */}
      <div
        style={{
          position: "absolute",
          top: "52%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "80%",
          maxWidth: "700px",
          height: "40%",
          border: "3px solid #00A650",
          borderRadius: "12px",
          pointerEvents: "none",
          zIndex: 1,
        }}
      />
      <div
        style={{
          position: "absolute",
          top: "75%",
          left: "50%",
          transform: "translateX(-50%)",
          textAlign: "center",
        }}
      >
        <Text color="inverted" type="h100" alignment="center">
          {isScanning ? "Position barcode within frame" : "Processing..."}
        </Text>
      </div>
    </div>
  );
};

export default BarcodeScanner;
